"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoOrientation;
(function (VideoOrientation) {
    VideoOrientation["LANDSCAPE"] = "LANDSCAPE";
    VideoOrientation["LANDSCAPE_FLIPPED"] = "LANDSCAPE_FLIPPED";
})(VideoOrientation || (VideoOrientation = {}));
exports.default = VideoOrientation;
